import { render, staticRenderFns } from "./PlatenSetting.vue?vue&type=template&id=2c23fe79&scoped=true&"
import script from "./PlatenSetting.vue?vue&type=script&lang=js&"
export * from "./PlatenSetting.vue?vue&type=script&lang=js&"
import style0 from "./PlatenSetting.vue?vue&type=style&index=0&id=2c23fe79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23fe79",
  null
  
)

export default component.exports